import { z } from 'zod';

import type { GeneralAgentInput } from '@/lib/api/domains/general-agents';

/*
 * General-agent form schema. Mirrors the provider/agent-broker/invoice/client
 * form pattern: a Zod schema for the fields the user edits, plus a
 * `toGeneralAgentInput` transform to the API input shape. Optional text fields
 * normalize empty strings to `undefined` so we never send a blank DBA/NPN to
 * the BFF. (The prototype general-agent record has no type field, so — unlike
 * agents-brokers — there is no `agentType`.)
 */
export const generalAgentFormSchema = z.object({
  name: z.string().min(1, 'Name is required.'),
  dbaName: z.string().optional(),
  npn: z.string().optional(),
  status: z.enum(['active', 'inactive']),
});

export type GeneralAgentFormValues = z.infer<typeof generalAgentFormSchema>;

/** Convert form values to the API input shape (drops blank optionals). */
export function toGeneralAgentInput(
  values: GeneralAgentFormValues,
): GeneralAgentInput {
  return {
    name: values.name,
    status: values.status,
    ...(values.dbaName?.trim() ? { dbaName: values.dbaName.trim() } : {}),
    ...(values.npn?.trim() ? { npn: values.npn.trim() } : {}),
  };
}
